export default __webpack_public_path__ + "static/media/human-digestive.34e17ef9.svg";